import React from "react";
import RenewalPage from "./pages/renewal/renewalPage";

function App() {
	return <RenewalPage />;
}

export default App;
